export const escolas = {
    "3040": {
        pt: "Instituto Politécnico de Bragança",
        en: "Polytechnic Institute of Bragança"
    },
    "3041": {
        pt: "Escola Superior Agrária",
        en: "School of Agriculture "
    },
    "3042": {
        pt: "Escola Superior de Educação",
        en: "School of Education"
    },
    "3043": {
        pt: "Escola Superior de Tecnologia e Gestão",
        en: "School of Technology and Management"
    },
    "3045": {
        pt: "Escola Superior de Comunicação, Administração e Turismo",
        en: "School of Public Management, Communication and Tourism"
    },
    "3046": {
        pt: "Escola Superior de Hotelaria e Bem-Estar",
        en: "School of Hospitality and Wellness"
    },
    "7015": {
        pt: "Escola Superior de Saúde",
        en: "School of Health"
    }
}

export const campus = {
    "3040": {
        pt: "Santa Apolónia - Bragança",
        en: "Santa Apolónia - Bragança"
    },
    "3041": {
        pt: "Santa Apolónia - Bragança",
        en: "Santa Apolónia - Bragança"
    },
    "3042": {
        pt: "Santa Apolónia - Bragança",
        en: "Santa Apolónia - Bragança"
    },
    "3043": {
        pt: "Santa Apolónia - Bragança",
        en: "Santa Apolónia - Bragança"
    },
    "3045": {
        pt: "Cruzeiro - Mirandela",
        en: "Cruzeiro - Mirandela"
    },
    "3046": {
        pt: "Campus da Água - Chaves",
        en: "Água Campus - Chaves"
    },
    "7015": {
        pt: "Santa Apolónia - Bragança",
        en: "Santa Apolónia - Bragança"
    }
}

export const header = {
    "codigo": {
        pt: "Código",
        en: "Code"
    },
    "tipo": {
        pt: "Grau",
        en: "Degree"
    },
    "curso": {
        pt: "Curso",
        en: "Course"
    },
    "escola": {
        pt: "Escola",
        en: "School"
    },
    "campus": {
        pt: "Campus",
        en: "Campus"
    }
}

export const search = {
    pt: "Pesquisar curso...",
    en: "Search course..."
}

export const details = {
    "diretor": {
        pt: "Diretor(a) de Curso",
        en: "Course Director"
    }, 
    "areas": {
        pt: "Áreas Científicas que integram o plano de estudos",
        en: "Scientific areas included in the study plan."
    },
    "notFound": {
        pt: "Curso não encontrado",
        en: "Course not found"
    },
    "headerAreas": {
        "area": {
            pt: "Área Científica",
            en: "Scientific Area"
        },
        "sigla": {
            pt: "Sigla",
            en: "Acronym"
        },
        "ectsOb": {
            pt: "ECTS Obrigatórios",
            en: "Required ECTS Credits"
        },
        "ectsOp": {
            pt: "ECTS Opcionais",
            en: "Optional ECTS Credits"
        }
    },
    "plano": {
        pt: "Plano de Estudos",
        en: "Study Plan"
    },
    "headerPlano": {
        "codigo": {
            pt: "Código",
            en: "Code"
        },
        "unidade": {
            pt: "Unidade Curricular",
            en: "Course Unit"
        },
        "ano": {
            pt: "Ano",
            en: "Year"
        },
        "tipo": {
            pt: "Tipo",
            en: "Type"
        },
        "area": {
            pt: "Área Científica",
            en: "Scientific Area"
        },
        "ects": {
            pt: "ECTS",
            en: "ECTS Credits"
        }
    },
    "ramo": {
        pt: "Ramo",
        en: "Branch"
    },
    "planoNovo": {
        pt: "Plano NOVO",
        en: "NEW Plan"
    }
}

export const info = {
    "adicional": {
        pt: "Informação adicional para candidatos",
        en: "Additional information for candidates"
    },
    "diploma": {
        pt: "Diploma Conferido",
        en: "Diploma Awarded"
    },
    "nivel": {
        pt: "Nível da Qualificação",
        en: "Qualification Level"
    },
    "requisitos": {
        pt: "Requisitos de Acesso",
        en: "Access Requirements"
    },
    "creditacao": {
        pt: "Creditação das aprendizagens prévias",
        en: "Recognition of prior learning."
    },
    "qualificacao": {
        pt: "Requisitos da qualificação e regulamentos",
        en: "Qualification requirements and regulations"
    },
    "perfil": {
        pt: "Perfil do Programa de estudos",
        en: "Study Program Profile"
    },
    "aprendizagem": {
        pt: "Principais resultados da aprendizagem",
        en: "Key learning outcomes"
    },
    "diplomados": {
        pt: "Perfil ocupacional dos diplomados",
        en: "Occupational profile of graduates"
    },
    "acesso": {
        pt: "Acesso a outros ciclos de estudos",
        en: "Access to other study cycles"
    },
    "graduacao": {
        pt: "Requisitos de graduação",
        en: "Graduation requirements"
    },
    "regulamentos": {
        pt: "Regulamentos de exames, avaliação e classificação",
        en: "Regulations for examinations, assessment and grading."
    },
    "regime": {
        pt: "Regime de estudos",
        en: "Study regime"
    },
    "acreditacao": {
        pt: "Acreditação/Registo",
        en: "Accreditation/Registration"
    },
    "documentos": {
        pt: "Documentos adicionais",
        en: "Additional documents"
    }
}

export const tipoCurso = {
    "L": {
        pt: "Licenciatura",
        en: "Bachelor"
    },
    "M": {
        pt: "Mestrado",
        en: "Master"
    },
    "D": {
        pt: "Doutoramento",
        en: "Doctorate"
    }
}